// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-period-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-tertiary);
  cursor: pointer;
  user-select: none;
}

.time-period-row:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.time-period-row-expandable {
  position: relative;
}

.time-period-arrow {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: transform 0.2s;
  cursor: pointer;
}

.time-period-arrow svg {
  width: 20px;
  height: 20px;
}

.time-period-arrow-up {
  transform: rotate(180deg);
}

.time-period-section:not(:last-child) {
  border-bottom: 1px solid var(--border-tertiary);
}

.time-period-section .time-period-row {
  border-bottom: none;
}

.time-period-buttons {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 16px 16px 24px;
}

.time-period-button {
  padding: 9px 16px;
  background: var(--row-dark);
  border: 1px solid var(--tab-filter-off-surface);
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-primary);
  text-align: center;
  transition: all 0.15s;
  width: 66px;
  box-sizing: border-box;
}

.time-period-button:hover {
  background: var(--color-brand-hover2);
}

.time-period-button-active {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: #fff;
  &:hover {
    background: var(--color-brand);
    opacity: 0.9;
  }
}

@container (max-width: 600px) {
  .time-period-popup {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/TimePeriodSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;EACX;IACE,8BAA8B;IAC9B,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".time-period-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-tertiary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.time-period-row:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.time-period-row-expandable {\n  position: relative;\n}\n\n.time-period-arrow {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  transition: transform 0.2s;\n  cursor: pointer;\n}\n\n.time-period-arrow svg {\n  width: 20px;\n  height: 20px;\n}\n\n.time-period-arrow-up {\n  transform: rotate(180deg);\n}\n\n.time-period-section:not(:last-child) {\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.time-period-section .time-period-row {\n  border-bottom: none;\n}\n\n.time-period-buttons {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  padding: 16px 16px 24px;\n}\n\n.time-period-button {\n  padding: 9px 16px;\n  background: var(--row-dark);\n  border: 1px solid var(--tab-filter-off-surface);\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--text-primary);\n  text-align: center;\n  transition: all 0.15s;\n  width: 66px;\n  box-sizing: border-box;\n}\n\n.time-period-button:hover {\n  background: var(--color-brand-hover2);\n}\n\n.time-period-button-active {\n  background: var(--color-brand);\n  border-color: var(--color-brand);\n  color: #fff;\n  &:hover {\n    background: var(--color-brand);\n    opacity: 0.9;\n  }\n}\n\n@container (max-width: 600px) {\n  .time-period-popup {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
